import axios from "axios";
import Encrypt from "../utils/encode";

// const baseURL = "http://localhost:5011/";
const baseURL = "/";
// const baseURL="https://mvgn.quizmasterr.com/";

export const login = async (data) => {
    const response = await axios.post(`${baseURL}api/v1/login`, data);
    return response;
};

export const getFunFact = async () => {
    const response = await axios.get(`${baseURL}api/v1/fun-facts`);
    return response;
};

export const getProfile = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-user-profile`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return response;
};

export const getAllQuiz = async (language, token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-all-quizes?lang_id=${language}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return response;
};

export const getQuiz = async (quizId, levelId, currentLanguage, token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-quiz/${quizId}/${levelId}?lang_id=${currentLanguage}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

    return response;
}

export const getQuizDetails = async (quizId, levelId, currentLanguage, token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-quiz/${quizId}/${levelId}?lang_id=${currentLanguage}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response?.data?.result?.data;
}

export const getLeaderboard = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-leaderboard`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
};

export const updateProfile = async (formData, token) => {
    try {
        const response = await axios.post(`${baseURL}api/v1/protected/edit-profile`, formData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data.data;
    } catch (e) {
        console.log(e);
    }
};

export const getHistory = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-history?offset=0`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
};

export const getAllOpponent = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/finding-opponent`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
};

export const saveUserPoints = async (quizId, quizName, quizImage, levelId, points, totalPoints, token) => {

    const encryptPayload = Encrypt({
        quizId: quizId,
        quizName: quizName,
        quizImage: quizImage,
        levelId: levelId,
        userPoints: points,
        totalPoints: totalPoints
    })

    const response = await axios.post(`${baseURL}api/v1/protected/save-user-points`, encryptPayload, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        }
    });
    return response;
};

export const getReverseQuizQuestions = async (level, language_id, token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-reverse-quiz-questions?level=${level}&language_id=${language_id}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const saveReverseQuizPoints = async (levelId, points, totalPoints, token) => {

    const encryptPayload = Encrypt({
        levelId: levelId,
        userPoints: points,
        totalPoints: totalPoints
    })

    const response = await axios.post(`${baseURL}api/v1/protected/save-reverse-quiz-points`, encryptPayload, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        }
    });

    return response;
}

export const checkUserSubscription = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/check-user-subscription`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const saveWordGamePointsApi = async (levelId, points, totalPoints, token) => {
    const encryptPayload = Encrypt({
        levelId: levelId,
        userPoints: points,
        totalPoints: totalPoints
    })

    const response = await axios.post(`${baseURL}api/v1/protected/save-word-game-points`, encryptPayload, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        }
    });

    return response;
}

export const weeklyLeaderboardApi = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/weekly-leaderboard`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    });

    return response;
}

const Integrated_API_URL = "https://api-mvgn.quizmasterr.com/";
// const Integrated_API_URL = "/";

export const SendOtpAPI = async (msisdn) => {
    const response = await axios.post(`${Integrated_API_URL}OTP/SendOTP`, {
        msisdn
    });
    return response;
}

export const VerifyOtpAPI = async (msisdn, otp) => {
    const response = await axios.post(`${Integrated_API_URL}OTP/verifyOTP`, {
        msisdn,
        otp
    });
    return response;
}

export const confirmSubAPI = async (msisdn, ext_ref, pack_type) => {
    const response = await axios.post(`${Integrated_API_URL}activate-user`, { msisdn, ext_ref, pack_type });
    return response;
}

export const unsubscribeAPI = async (msisdn) => {
    const response = await axios.post(`${Integrated_API_URL}deactivate-user`, { msisdn });
    return response;
}

export const chargeUserApi = async (msisdn) => {
    const response = await axios.post(`${Integrated_API_URL}charge-user`, {
        msisdn
    });
    return response;
}

// Zip Game Apis

export const zipSendOtpApi = async (msisdn) => {
    const response = await axios.post(`${baseURL}api/v1/zip-game/send-otp`, {
        msisdn
    });
    return response;
}

export const zipVerifyOtpApi = async (msisdn, otp) => {
    const response = await axios.post(`${baseURL}api/v1/zip-game/verify-otp`, {
        msisdn,
        otp
    });
    return response;
}

export const registerZipUser = async (msisdn) => {
    const response = await axios.post(`${baseURL}api/v1/zip-game/register`, {
        msisdn
    });
    return response;
}

export const loginZipUser = async (msisdn) => {
    const response = await axios.post(`${baseURL}api/v1/zip-game/login`, {
        msisdn
    });
    return response;
}

export const zipPlayGame = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/zip-game/play`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const zipSaveScore = async (token, total_time_seconds, moves, game_trx_id) => {
    const response = await axios.post(`${baseURL}api/v1/zip-game/save-score`, { total_time_seconds, moves, game_trx_id },
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    return response;
}

export const zipGameResult = async (game_trx_id, token) => {
    const response = await axios.get(`${baseURL}api/v1/zip-game/user-game-result?game_trx_id=${game_trx_id}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const zipGameLeaderboardApi = async (date, token) => {
    const response = await axios.get(`${baseURL}api/v1/zip-game/leaderboard?date=${date}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const zipGameWinnersApi = async (date, token) => {
    const response = await axios.get(`${baseURL}api/v1/zip-game/winners?date=${date}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const checkZipUserSubscription = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/zip-game/auth/checker`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const zipUserProfileApi = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/zip-game/profile`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const zipUserProfileEditApi = async (formData, token) => {
    const response = await axios.post(`${baseURL}api/v1/zip-game/edit-profile`, formData, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const zipUserHistoryApi = async (page, token) => {
    const response = await axios.get(`${baseURL}api/v1/zip-game/history?page=${page}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}